import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs,EffectFade } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs'; 

document.addEventListener('DOMContentLoaded', () => {

const swiper1 = document.querySelector('.swiper');
const swiperImage = document.querySelector('.swiper-image');
const gallery = document.querySelector('.gallery');



const baseConfig = {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 600,
      slidesPerView: 1,
       breakpoints: {
    768: {
      slidesPerView: 'auto',
      spaceBetween: 20
    },}
};
if (swiper1) {
  const swiper = new Swiper(swiper1, {
    ...baseConfig,
    navigation: {
        nextEl: '.sbutton-next',
        prevEl: '.sbutton-prev',
    },
});  
}

if (swiperImage) {
  const swiperInstance2 = new Swiper(swiperImage, {
    ...baseConfig,
    loop:false,
    navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
    },
});  
}

if (gallery) {
  const swiperInstance2 = new Swiper(gallery, {
    // ...baseConfig,
    loop:true,
    slidesPerView: 1,
     spaceBetween: 0,
    autoplay:true,
    effect:'fade',
       speed: 900,
    navigation: {
        nextEl: '.gallery-next',
        prevEl: '.gallery-prev',
    },
});  
}


const packagesTabs = document.querySelectorAll('.packages-tabs .tab');
const packagesContents = document.querySelectorAll('.pkg-content');
if (packagesTabs.length > 0) {
    
  packagesTabs.forEach((ctx,index)=>{
    ctx.addEventListener('click',()=>{
       packagesTabs.forEach(t => t.classList.remove('active'));
       packagesContents.forEach(с => с.classList.remove('active'));

      ctx.classList.add('active');
      packagesContents[index].classList.add('active');
    })
  })

}


const showPackage = document.querySelectorAll('.show-pack');

if (showPackage.length > 0) {
  
  showPackage.forEach((ctx)=>{

      ctx.addEventListener('click',()=>{
          const parent = ctx.closest('.item');
          parent.classList.toggle('active');

      });


  });
}


const techTabs = document.querySelectorAll('.tech-tabs .t-tab');
const techContaiers = document.querySelectorAll('.tech-container');

if (techTabs.length > 0) {
  console.log(1)
techTabs.forEach((el,ind)=>{
      el.addEventListener('click',()=>{
       techTabs.forEach(t => t.classList.remove('active'));
       techContaiers.forEach(с => с.classList.remove('active'));

      el.classList.add('active');
      techContaiers[ind].classList.add('active');


      })

});

}


const openTech = document.querySelector('.open-tech');
if (openTech) {
  
  openTech.addEventListener('click',()=>{
        techContaiers.forEach((el)=>{
            el.classList.toggle('height');
        });  

  openTech.classList.toggle('active');
  
  if (openTech.classList.contains('active')) {
    openTech.innerHTML = '<span></span>Свернуть';
  }
  else {
      openTech.innerHTML = '<span></span> Все технические характеристики';
        const element = document.querySelector('.tech');
    
    element.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // 'start', 'center', 'end', или 'nearest'
        inline: 'nearest'
    });


  }

  });


}




});




